export default __webpack_public_path__ + "static/media/715.06c5bd88.png";